import { Button, styled, CSSObject, ButtonProps } from '@mui/material';

interface CustomButtonProps extends Omit<ButtonProps, 'color'> {
  customColor?: string;
}

const StyledButton = styled(Button)<CustomButtonProps>(({
  theme,
  customColor,
  variant,
}) => {
  const overrides: CSSObject = {};

  if (customColor) {
    if (variant === 'contained') {
      overrides.backgroundColor = customColor;
      overrides.color = theme.palette.getContrastText(customColor);
    } else if (variant === 'outlined') {
      overrides.borderColor = customColor;
      overrides.color = customColor;
    }
  }

  return overrides;
});

export default StyledButton;
